import * as React from "react";

interface Props {
  classWrap: string;
}

const CountWrapper: React.FC<Props> = ({ classWrap }) => (
  <div id="wrap" className={classWrap}>
    <div className="c" />
    <div className="o" />
    <div className="u" />
    <div className="n" />
    <div className="t" />
  </div>
);

export default CountWrapper;
